import { district_heating_availability_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateDistrictHeatingAvailabilityEnum = (enumValue: district_heating_availability_enum) => {
  switch (enumValue) {
    case district_heating_availability_enum.UNKNOWN:
      return <Trans i18nKey="Enum_DistrictHeatingAvailabilityEnum-UNKNOWN" />;
    case district_heating_availability_enum.PLANNED:
      return <Trans i18nKey="Enum_DistrictHeatingAvailabilityEnum-PLANNED" />;
    case district_heating_availability_enum.UNPLANNED:
      return <Trans i18nKey="Enum_DistrictHeatingAvailabilityEnum-UNPLANNED" />;
    case district_heating_availability_enum.AVAILABLE:
      return <Trans i18nKey="Enum_DistrictHeatingAvailabilityEnum-AVAILABLE" />;
  }
};

export const translateDistrictHeatingAvailabilityEnum_dynamic = (enumValue: district_heating_availability_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case district_heating_availability_enum.UNKNOWN:
      return t('Enum_DistrictHeatingAvailabilityEnum-UNKNOWN');
    case district_heating_availability_enum.PLANNED:
      return t('Enum_DistrictHeatingAvailabilityEnum-PLANNED');
    case district_heating_availability_enum.UNPLANNED:
      return t('Enum_DistrictHeatingAvailabilityEnum-UNPLANNED');
    case district_heating_availability_enum.AVAILABLE:
      return t('Enum_DistrictHeatingAvailabilityEnum-AVAILABLE');
  }
};
